<template>
  <span class="text-link" :class="{ black: isBlack }" @click="onClick">
    {{ text }}
  </span>
</template>

<script>
export default {
  name: "text-link-inline",
  props: {
    text: { type: String },
    isBlack: { type: Boolean, default: false },
  },
  methods: {
    onClick() {
      this.$emit("click-text", this.text);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.text-link {
  color: #5cd5d6;
  margin: 0em;
  text-align: center;
  &.black {
    color: #373737;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/TextLinkInline.vue